module.exports = __webpack_public_path__ + "static/media/dm2.ef2be08c.svg";